import React from "react";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import useGetDisclosure from "@fartherfinance/frontend/api/Document/hooks/useGetDisclosure";
import { DisclosureType } from "@fartherfinance/frontend/api/Document/requests/types";

import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./Disclosure.module.css";

export interface DisclosureProps {
  type: DisclosureType;
  header: string;
  description: string;
}

// TODO: useGetDocumentFile might be needed

const Disclosure: React.FC<DisclosureProps> = ({
  type,
  header,
  description,
}) => {
  const auth = useRequestAuth();
  const disclosure = useGetDisclosure(type, auth);

  const handleOpenDisclosure = (): void => {
    if (disclosure.data) {
      window.open(disclosure.data, "_blank");
    }
  };

  const Content = (
    <div
      className={toClassName(styles.container, {
        [styles.disabled]: disclosure.hasError,
      })}
      onClick={handleOpenDisclosure}
    >
      <div className={styles.header}>
        <Text variant="title2">{header}</Text>
        <ArrowForwardIosIcon className={styles.icon} />
      </div>

      <Text variant="body">{description}</Text>
    </div>
  );

  return disclosure.isLoading ? <Skeleton>{Content}</Skeleton> : <>{Content}</>;
};

export default Disclosure;
